import { configureStore } from '@reduxjs/toolkit';
import claimCreationReducer from './ClaimCreation/ClaimCreationSlice';
import claimDetailReducer from './ClaimDetails/ClaimDetailSlice';
import claimsReducer from './Claims/ClaimsSlice';
import { contextRouterReducer } from './ContextRouter/ContextRouterSlice';
import eligibilityServiceSliceReducer from './EligibilityService/EligibilityServiceSlice';
import optimizelyFeatureFlagsReducer from './OptimizelyFlags/OptimizelyFlagsSlice';
import policiesReducer from './Policies/PoliciesSlice';
import thirdPartyClaimReducer from './ThirdPartyClaim/ThirdPartyClaimSlice';

export const store = configureStore({
  reducer: {
    services: eligibilityServiceSliceReducer,
    contextRouter: contextRouterReducer,
    claimDetail: claimDetailReducer,
    claims: claimsReducer,
    policies: policiesReducer,
    claimCreation: claimCreationReducer,
    thirdPartyClaims: thirdPartyClaimReducer,
    optimizelyFlags: optimizelyFeatureFlagsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
